"use client";

import { createContext, useContext, useMemo, type ReactNode } from "react";
import { type EcolabNews } from "types/ContentHub/News";

export type NewsContextProps = {
  news?: EcolabNews;
  newsSlug: string;
};

const NewsContext = createContext<NewsContextProps>({
  news: undefined,
  newsSlug: "",
});

interface NewsProviderProps {
  children: ReactNode;
  news?: EcolabNews;
  newsSlug: string;
}

export const NewsProvider = ({
  children,
  news,
  newsSlug,
}: NewsProviderProps) => {
  const contextValue = useMemo(() => ({ news, newsSlug }), [news, newsSlug]);
  return (
    <NewsContext.Provider value={contextValue}>{children}</NewsContext.Provider>
  );
};

export const useNewsContext = (): NewsContextProps => useContext(NewsContext);
